<template>
  <v-container class="quicksand">
    <v-row justify="center">
      <v-card
        max-width="1000"
        width="100%"
        class="elevation-0 transparent"
      >
        <v-breadcrumbs
          :items="breadCrumbs"
          divider="/"
          class="pl-0 mx-4"
        />
      </v-card>
    </v-row>
    <v-row justify="center">
      <v-card
        outlined
        class="pa-2 mt-4 mx-4 helmi-card"
        width="100%"
        max-width="1000"
      >
        <div class="helmi-card-title pl-2 pt-2">
          Uusi sähköinen ostotarjous
        </div>
        <div class="helmi-card-subtitle pl-2 pt-1 pb-1">
          Kohde: {{ property.kohdenimi }} {{ property.huoneistonro }}
        </div>

        <v-list rounded>
          <v-list-item-group color="primary">
            <template
              v-for="(item, index) in form.offerers"
            >
              <v-menu :key="index" offset-y>
                <template v-slot:activator="{ on }">
                  <v-list-item
                    class="grey lighten-4"
                    v-on="on"
                  >
                    <v-list-item-icon class="mr-4">
                      <v-icon class="primary--text my-1" large>
                        account_circle
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="primary--text">
                        {{ item.name }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        {{ item.email }}
                      </v-list-item-subtitle>
                      <v-list-item-subtitle v-if="!item.isCompany">
                        {{ item.assetTransfer ? 'Varainsiirtoverovelvollinen: Ei' :
                          'Varainsiirtoverovelvollinen' }}
                      </v-list-item-subtitle>
                      <v-list-item-subtitle v-else>
                        Yritys: {{ item.companyName }} {{ item.companyNumber }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <v-list>
                  <v-list-item @click="editOfferer(index)">
                    <v-list-item-title>Muokkaa</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="removeOfferer(index)">
                    <v-list-item-title>Poista</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-list-item-group>
          <v-dialog
            v-model="dialog"
            :fullscreen="$vuetify.breakpoint.smAndDown"
            width="550"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                color="primary"
                class="ml-0 mt-2"
                large
                v-on="on"
              >
                Lisää tarjoaja
                <v-icon right dark>
                  person_add
                </v-icon>
              </v-btn>
            </template>
            <offerer-form
              :new-person="newPerson"
              :form="form"
              :indexes="indexes"
              :editing="editing"
              :duplicates="duplicates"
            />
          </v-dialog>
        </v-list>
        <v-alert
          v-if="duplicates.offererEmail"
          class="mx-4"
          type="warning"
          dense
          text
        >
          Tarjoajilla tulee olla eri sähköpostiosoitteet
        </v-alert>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            :disabled="form.offerers.length < 1 || duplicates.offererEmail"
            large
            class="px-4"
            color="primary"
            @click="createOffer()"
          >
            Luo tarjous
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-row>
  </v-container>
</template>
<script>
import _ from 'lodash';
import { mapActions } from 'vuex';
import { apiGet, apiPost } from '../api';

export default {
  components: {
    'offerer-form': () => import('@/components/OffererForm'),
  },
  data: () => ({
    property: {},
    dialog: false,
    editing: {
      offerer: false,
    },
    indexes: {
      offerer: null,
    },
    duplicates: {
      offererEmail: false,
    },
    newPerson: {
      isCompany: false,
      companyName: '',
      companyNumber: '',
      name: '',
      email: '',
      assetTransfer: false,
      nationality: 'Suomi',
      address: '',
      phone: '',
      pep: false,
      pepDescription: '',
    },
    form: {
      offerers: [],
    },
    rules: {
      required: value => !!value || 'Pakollinen kenttä.',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Virheellinen sähköpostiosoite.';
      },
    },
  }),
  computed: {
    breadCrumbs() {
      if (!this.property) return [];
      return [
        {
          disabled: false,
          href: this.property.propertypath,
          link: true,
          text: this.property.kohdenimi,
        }, {
          disabled: false,
          link: false,
          text: 'Uusi sähköinen ostotarjous',
        }];
    },
  },
  async mounted() {
    const response = await apiGet(`properties/basicdetails/${this.$route.params.id}`);
    this.property = response.result;
    await this.setCurrentProperty(this.$route.params.id);
  },
  created() {
    this.$bus.$on('closeOffererDialog', async () => {
      this.closeOffererDialog();
    });
  },
  methods: {
    ...mapActions({
      setCurrentProperty: 'setCurrentProperty',
    }),
    editOfferer(index) {
      this.newPerson = _.cloneDeep(this.form.offerers[index]);
      this.indexes.offerer = index;
      this.dialog = true;
      this.editing.offerer = true;
    },
    removeOfferer(index) {
      this.form.offerers.splice(index, 1);
    },
    closeOffererDialog() {
      this.dialog = false;
      this.newPerson.isCompany = false;
      this.editing.offerer = false;
      this.indexes.offerer = null;
    },
    async createOffer() {
      const params = {
        offerers: this.form.offerers,
      };
      const response = await apiPost(`properties/createofferform/${this.$route.params.id}`, params);
      if (response.success) {
        const { offerId } = response;
        this.$router.push(`/${this.$route.params.companyId}/offer/${this.$route.params.id}/${offerId}`);
      }
    },
  },
};
</script>
